import React, {Component} from "react";
import {connect} from "react-redux";
import {Button, Divider, Input, message, Modal, Progress, Row, Select, Spin, Table, Tooltip} from "antd";
import {openEndPoint} from "../utils/utils";
import {get, get_response, post} from "../helper/request";
import Text from "antd/es/typography/Text";
import {
    CloseOutlined,
    DeleteFilled,
    ImportOutlined,
    InfoCircleOutlined,
    PlayCircleOutlined,
    ReloadOutlined,
    SearchOutlined
} from "@ant-design/icons";
import Title from "antd/es/typography/Title";

import "../asset/style/import_scans.css";
import {isDeviceIPRemote} from "../utils/device_utils";

const {Option} = Select;
const SOURCE_DIR = "/home/morphle/Desktop/ndpi_scans/";
const PAGE_SIZE = 7
const IMPORT_STATUS_MAP = {
    0: "Not scheduled",
    1: "Scheduled",
    2: "In Progress",
    3: "Failed",
    4: "Import Completed"
}

const fetchPaginatedData = (pageNumber, filters, successCallback, errorCallback) => {
    let url = "/api/get_import_scan_list/?page=" + pageNumber + "&per_page=" + PAGE_SIZE
    if (Object.keys(filters).length > 0) {
        console.log("Filter: ", filters)
        if ("import_status" in filters) {
            url += "&import_status=" + filters["import_status"];
        }

        if ("starts_with" in filters) {
            url += "&starts_with=" + filters["starts_with"];
        }
    }

    get_response(url)
        .then((response) => {
            if (response.status === 200) {
                return successCallback(response.data);
            }

            console.warn("Some error occurred: ", response)
            errorCallback(response);
        })
        .catch((err) => {
            console.log("Error: ", err)
            errorCallback(err);
        })
}

const StartImportButton = ({handleStartImport}) => {
    return <Tooltip placement="bottomRight" title="Schedule Import"
                    className="icon-hover slide-icons"
                    style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "center",
                        alignItems: "center",
                    }}>
        <PlayCircleOutlined
            onClick={(event) => {
                event.stopPropagation();
                handleStartImport();
            }}
            type="build"
        />
    </Tooltip>
}

const TableActionRow = (props) => {
    const {
        handleReloadFiles, handleStartsWithFilter, handleStatusFilter,
        clearFilters, scheduleAllForImport, scheduleAllForDelete, selectedItemsLen
    } = props;
    return <Row type={"flex"}>

        <Input.Search
            style={{marginLeft: "10%", marginRight: "10%", marginBottom: "10px"}}
            placeholder="Search file name..."
            enterButton={<SearchOutlined/>}
            onSearch={handleStartsWithFilter}
        />

        <Button style={{margin: "10px"}} onClick={handleReloadFiles}>
            <ReloadOutlined></ReloadOutlined>
            Reload files
        </Button>

        <Select defaultValue={"All"} onChange={handleStatusFilter} style={{width: 200, margin: "10px"}}>
            {Object.keys(IMPORT_STATUS_MAP).map((key) => (
                <Option key={key} value={key}>
                    {IMPORT_STATUS_MAP[key]}
                </Option>
            ))}
            <Option key={"All"} value={"all"}>
                All
            </Option>
        </Select>

        <Button style={{margin: 10}} onClick={scheduleAllForImport} disabled={selectedItemsLen === 0}>
            <ImportOutlined></ImportOutlined>
            Schedule for Import
        </Button>

        <Button style={{margin: 10}} onClick={scheduleAllForDelete} disabled={selectedItemsLen === 0}>
            <DeleteFilled></DeleteFilled>
            Delete Source File
        </Button>

        <Button style={{margin: 10}} onClick={clearFilters}>
            <CloseOutlined></CloseOutlined>
            Clear Filter
        </Button>
    </Row>
}

const DeleteSourceFileButton = ({handleDelete}) => {
    return <Tooltip placement="bottomRight" title="Delete source file"
                    className="icon-hover slide-icons"
                    style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "center",
                        alignItems: "center",
                    }}>
        <DeleteFilled
            onClick={(event) => {
                event.stopPropagation();
                handleDelete();
            }}
            type="build"
        />
    </Tooltip>
}

const ImportStatusComponent = ({text, record}) => {
    if (text === 2) {
        return (
            <div>
                <Text>{IMPORT_STATUS_MAP[text]}</Text>
                <Progress width={10} type={"line"} percent={record["progress"]}></Progress>
            </div>
        )
    }

    return (
        <Text>{IMPORT_STATUS_MAP[text]}</Text>
    )
}

class TableView extends Component {

    constructor(props) {
        super(props);

        this.state = {
            selectedItems: [],
            pagination: {current: 1, total_items: 0},
            spinning: false,
            filters: {},
        }

        this.poller = null;
    }

    handleStartImport = (filePaths) => {
        console.log("[IMPORT]: ", filePaths);
        // API call to start import for given entry
        const url = "/api/schedule_for_import/";
        let data = {
            file_paths: filePaths
        }

        post(url, data)
            .then(result => {
                message.info(result["msg"])
                this.updateTableData(this.state.pagination.current)
            })
            .catch(err => {
                console.error(err);
                message.error("Some error occurred in scheduling import")
            })
    }

    handleDeleteSourceFile = (filePaths) => {
        // API call to start import for given entry
        const url = "/api/delete_source_file_of_imported_scan/";
        let data = {
            file_paths: filePaths
        }
        post(url, data)
            .then(result => {
                if (result["showWarningForUndeletedFile"] === true) {
                    message.warn("Couldn't delete source file which are not yet imported.");
                } else {
                    message.success("Successfully deleted source file.")
                }

            })
            .catch(err => {
                console.log("Error: ", err);
                message.error("Some issue occurred while deleting!");
            })
    }

    updateTableData = (pageNumber) => {
        fetchPaginatedData(pageNumber, this.state.filters, (result) => {
            console.log("Result: ", result)
            let pagination = result.page
            this.setState({
                pagination: pagination,
                data: result.data
            })
        }, () => {
            message.error("Some error occurred while fetching data.");
        })
    }

    handleReloadFiles = () => {
        // trigger jenkins job to reload SlideImportState table
        this.setState({spinning: true})
        let url = "/api/reload_import_files/";
        get(url)
            .then(result => {
                console.log("Jenkins: ", result);
                this.setState({spinning: false})
                this.updateTableData(this.state.pagination.current);
            })
            .catch(err => {
                console.error("Error: ", err)
                this.setState({spinning: false})
                message.error('Some issue occurred while reloading.')
                this.updateTableData(this.state.pagination.current);
            })
    }

    componentDidMount() {
        this.updateTableData(1)
        this.poller = setInterval(this.doPolling, 3000);
    }

    componentWillUnmount() {
        clearInterval(this.poller);
    }

    handleStatusFilterChange = (value) => {
        console.log("Status Filter: ", value);
        this.setState({filters: {...this.state.filters, "import_status": value}}, () => {
            this.updateTableData(this.state.pagination.current);
        })
    }

    handleStartsWithFilter = (value) => {
        this.setState({filters: {...this.state.filters, "starts_with": value}}, () => {
            this.updateTableData(this.state.pagination.current);
        })
    }

    scheduleAllForDelete = () => {
        let file_paths = [];
        this.state.selectedItems.forEach((key) => {
            file_paths.push(this.state.data[key]["file_path"]);
        })

        this.handleDeleteSourceFile(file_paths);
    }

    scheduleAllForImport = () => {
        let file_paths = [];
        this.state.selectedItems.forEach((key) => {
            file_paths.push(this.state.data[key]["file_path"]);
        })

        this.handleStartImport(file_paths);
    }

    clearAllFilters = () => {
        this.setState({filters: {}, selectedItems: []}, () => {
            this.updateTableData(this.state.pagination.current);
        })
    }

    doPolling = () => {
        this.updateTableData(this.state.pagination.current);
    }

    render() {

        const columns = [
            {
                title: 'File',
                dataIndex: 'file_path',
                render: (text, record) => record.source_file_deleted ? <Text>{text}</Text> :
                    <a onClick={() => openEndPoint("app://" + record.file_path, false, false)}>{text}</a>,
            },
            {
                title: 'Import Status',
                dataIndex: 'import_status',
                render: (text, record) => <ImportStatusComponent text={text} record={record}/>
            },
            {
                title: 'Viewer Link',
                dataIndex: 'viewer_link',
                render: (text, record) => text !== "" && record.import_status === 4 ?
                    <a href={text}>Open in viewer</a> : "Not yet imported",
            },
            {
                title: 'Actions',
                dataIndex: 'actions',
                key: 'actions',
                render: (_, record) => (
                    <div>
                        {
                            record.import_status === 0 ?
                                <StartImportButton
                                    handleStartImport={() => this.handleStartImport([record.file_path])}/> : null
                        }
                        {
                            record.import_status < 3 || record.source_file_deleted ? null :
                                <DeleteSourceFileButton
                                    handleDelete={() => {
                                        const this_ = this;
                                        Modal.confirm({
                                            title: 'Are you sure you want to delete the source (ndpi) file for selected scans.',
                                            icon: <InfoCircleOutlined></InfoCircleOutlined>,
                                            onOk() {
                                                this_.handleDeleteSourceFile([record.file_path])
                                            },
                                            onCancel() {
                                            }
                                        });
                                    }}>
                                </DeleteSourceFileButton>
                        }
                    </div>
                ),
            },
        ];

        return (
            <Spin spinning={this.state.spinning}>
                <div>
                    <Divider/>

                    <TableActionRow handleStatusFilter={this.handleStatusFilterChange}
                                    handleReloadFiles={this.handleReloadFiles}
                                    handleStartsWithFilter={this.handleStartsWithFilter}
                                    scheduleAllForImport={this.scheduleAllForImport}
                                    scheduleAllForDelete={() => {
                                        const this_ = this;
                                        Modal.confirm({
                                            title: 'Are you sure you want to delete the source (ndpi) files for selected scans.',
                                            icon: <InfoCircleOutlined></InfoCircleOutlined>,
                                            content: (
                                                <Row>Note: The files which are not yet imported will be skipped.</Row>),
                                            onOk() {
                                                this_.scheduleAllForDelete()
                                            },
                                            onCancel() {
                                            }
                                        });
                                    }}
                                    clearFilters={this.clearAllFilters}
                                    selectedItemsLen={this.state.selectedItems.length}/>

                    <Divider/>

                    <Table
                        className={"custom-table"}
                        rowSelection={{
                            selectedRowKeys: this.state.selectedItems,
                            onChange: (selectedRowKeys) => {
                                this.setState({selectedItems: selectedRowKeys})
                            }
                        }}
                        columns={columns}
                        dataSource={this.state.data}
                        pagination={{
                            current: this.state.pagination.current,
                            pageSize: PAGE_SIZE,
                            total: this.state.pagination.total_items,
                            onChange: this.updateTableData

                        }}
                    />
                </div>
            </Spin>
        );
    }
}


class ImportScansView extends Component {

    render() {
        return <div style={{backgroundColor: "white", width: "100%", height: "100%"}}
                    className={"import-scans-container"}>
            <Row className={"import-scans-header rounded-container"}>
                <Title level={1}>Import Scans</Title>
            </Row>
            <Divider/>
            <Row>
                <ul>
                    <li>
                        <Text>
                            To import tiff based files (ndpi/svs/...), add them to
                            <span>
                                {isDeviceIPRemote ? " " + SOURCE_DIR :
                                    <a onClick={() => openEndPoint("app://" + SOURCE_DIR, false, false)}>{" " + SOURCE_DIR}</a>}
                            </span>
                        </Text>
                    </li>
                    <br/>
                    <li>
                        <Text>
                            If files do not reflect here, please use the "Reload files" button to reload them.
                        </Text>
                    </li>
                    <br/>
                    <li>
                        <Text>
                            If Import progress is stuck for a long time and refreshing the page do not fix the
                            issue, please contact Morphle Support at:
                            <a href={"mailto:customer-support@morphle.in"}> customer-support@morphle.in</a>
                        </Text>
                    </li>
                </ul>
            </Row>
            <Divider/>
            <TableView/>
        </div>
    }
}

const mapStateToProps = (state, ownProps) => {
    return {};
};

export default connect(mapStateToProps)(ImportScansView);